import { StoreType } from 'utils/connect';

/**
 * Code-based allowlist for the consumer legal page authoring surface, mirroring
 * the server-side {@code LegalEditorAuthorizer} allowlist (both must stay in
 * sync). Engineers (global ENG role) are allowed separately via
 * {@code hasEngRoleSelector} so the break-glass path works.
 */
const legalEditorEmails: string[] = [
  'joseph.r.khammar@aexp.com',
  'ryan.deterding+legalreviewer@tockhq.com',
];

export default (state: StoreType) => legalEditorEmails.includes(state.app.patron.email);
